import { buildReducerWithOptions } from '../../../shared';
import type { NavigationState } from '../../state/view/navigationState';
import hubReducerHandler from './navigationReducerHandlers/hubReducerHandler';
import searchBoxReducerHandler from './navigationReducerHandlers/searchBoxReducerHandler';
import groupHubReducerHandler from './navigationReducerHandlers/groupsHubReducerHandler';

export type { NavigationState };

export default buildReducerWithOptions<NavigationState>({
    handlers: [hubReducerHandler, searchBoxReducerHandler, groupHubReducerHandler],
    done: {
        clickedLeftNavItemId: undefined,
        clickedHubPersona: undefined,
        currentQuery: undefined,
        mouseOverHubPersonaId: undefined,
        personaListCheckedHubPersonaDetails: [],
    },
});
export type { Action } from '../../../shared';
